<template>
  <div id="management-queue">
    <div class="table-section">
      <el-card class="box-card" shadow="never">
        <el-form
          :inline="true"
          :model="searchParams"
          class="form-inline"
          
        >
          <el-form-item label="业务类型">
            <el-select
              v-model.trim="searchParams.businessType"
              placeholder="业务类型"
            >
              <el-option
                v-for="item in businessTypeList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="合同编号">
            <el-input
              v-model.trim="searchParams.contractNumber"
              placeholder="合同编号"
            />
          </el-form-item>
          <el-form-item label="客户姓名">
            <el-input
              v-model.trim="searchParams.borrowerName"
              placeholder="客户姓名"
            />
          </el-form-item>
          <el-form-item label="商户简称">
            <el-input
              v-model.trim="searchParams.mertName"
              placeholder="商户简称"
            />
          </el-form-item>
          <el-form-item label="时间">
            <el-date-picker
              v-model.trim="timeRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              @change="timeChange"
            />
          </el-form-item>
          <el-form-item label="联系方式">
            <el-select
              v-model.trim="searchParams.contactTypeCode"
              placeholder="联系方式"
            >
              <el-option
                v-for="(item, index) in contactTypeCodeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="通话类型">
            <el-select
              v-model.trim="searchParams.callTypeCode"
              placeholder="通话类型"
            >
              <el-option
                v-for="(item, index) in callTypeCodeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="通话结果">
            <el-select
              v-model.trim="searchParams.contactResultCode"
              placeholder="通话结果"
            >
              <el-option
                v-for="(item, index) in contactResultCodeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="催收人员">
            <el-autocomplete
              v-model.trim="creatorName"
              :fetch-suggestions="querySearch"
              placeholder="催收人员"
              @select="handleSelect"
              @change="operatorChange"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="联系状态">
            <el-select v-model.trim="searchParams.contactStatusCode" placeholder="联系状态">
              <el-option
                v-for="item in contactStatusList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="clear">清空</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  @click="download"
              >导出</el-button
            >
          </el-form-item>
        </el-form>
      </el-card>
    </div>

    <div class="table-section">
      <el-table
        :data="manageCollectionLogsList"
        :header-row-style="headerRowStyle"
        border
        highlight-current-row
        max-height="550px"
      >
        <el-table-column prop="businessType" label="业务类型">
          <template slot-scope="scope">
            {{
              scope.row.businessType === "1"
                ? "爱分担"
                : scope.row.businessType === "2"
                ? "分担宝"
                : scope.row.businessType === "3"
                ? "助贷通道"
                : scope.row.businessType === "4"
                ? "好易付"
                : scope.row.businessType === "5"
                ? "实物租赁"
                : scope.row.businessType === "6"
                ? "乐享付"
                : "-"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="contractNumber" label="合同编号" width="200" />
        <el-table-column prop="borrowerName" label="客户姓名" />
        <el-table-column prop="mertName" label="商户简称" width="200" />
        <el-table-column prop="createdTime" label="时间" width="150" />
        <el-table-column prop="contactTypeValue" label="联系方式" />
        <el-table-column prop="contactName" label="联络人" />
        <el-table-column prop="contactPhone" label="联系电话" width="100" />
        <el-table-column prop="relationValue" label="关系" />
        <el-table-column prop="callTypeValue" label="通话类型" />
        <el-table-column prop="contactResultValue" label="通话结果" />
        <el-table-column prop="contactStatusValue" label="联系状态" />
        <el-table-column prop="overdueReasonValue" label="逾期原因" />
        <el-table-column prop="remindeContent" label="催记内容" />
        <el-table-column
          prop="promiseRepayTime"
          label="承诺还款时间"
          width="100"
        />
        <el-table-column prop="isRefund" label="是否退费">
          <template slot-scope="scope">
            {{
              scope.row.isRefund === "1"
                ? "是"
                : scope.row.isRefund === "0"
                ? "否"
                : "-"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="creatorName" label="催收人员" />
      </el-table>
    </div>

    <div class="pagination-section">
      <el-pagination
        :page-size="pageSize"
        :total="manageCollectionLogsListTotalCount"
        layout="total, prev, pager, next"
        @current-change="changePage"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getDictionaryList, exportCollectionLog, getUser } from "@/api/manage";

export default {
  name: "CollectionLog",
  data() {
    return {
      headerRowStyle: {
        "background-color": "#6584b4",
      },
      timeRange: "",
      creatorName: "",
      searchParams: {},
      pageSize: 20,
      page: 0,
      businessTypeList: [],
      divisionStatusList: [
        {
          label: "处理中",
          value: "0",
        },
        {
          label: "成功",
          value: "1",
        },
        {
          label: "失败",
          value: "2",
        },
      ],
      contactTypeCodeList: [],
      callTypeCodeList: [],
      contactResultCodeList: [],
      contactStatusList: []
    };
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "manageCollectionLogsList",
      "manageCollectionLogsListTotalCount",
    ]),
  },
  async created() {
    this.loadCollectionLogs();
    // 业务类型
    const businessTypeListRes = await getDictionaryList("fd_business_type");
    businessTypeListRes.data.map((item) => {
      this.businessTypeList.push({
        label: item.dictLabel,
        value: item.dictValue,
      });
    });
    // 联系方式
    const contactTypeCodeListRes = await getDictionaryList("contact_type");
    contactTypeCodeListRes.data.map((item) => {
      this.contactTypeCodeList.push({
        label: item.dictLabel,
        value: item.dictValue,
      });
    });
    // 通话类型
    const callTypeCodeListRes = await getDictionaryList("call_type");
    callTypeCodeListRes.data.map((item) => {
      this.callTypeCodeList.push({
        label: item.dictLabel,
        value: item.dictValue,
      });
    });
    // 通话结果
    const contactResultCodeListRes = await getDictionaryList("contact_result");
    contactResultCodeListRes.data.map((item) => {
      this.contactResultCodeList.push({
        label: item.dictLabel,
        value: item.dictValue,
      });
    });
    // 联系状态
    const contactStatusCodeData = await getDictionaryList('contact_status')
    contactStatusCodeData.data.map((item) => {
      this.contactStatusList.push({
        label: item.dictLabel,
        value: item.dictValue
      })
    })
  },
  methods: {
    ...mapActions(["fetchCollectionLogsList"]),
    loadCollectionLogs() {
      return this.fetchCollectionLogsList({
        searchParams: this.searchParams,
        currentPage: this.page,
        pageSize: this.pageSize,
        userId: this.currentUser.id,
      });
    },
    changePage(currentPage) {
      this.page = currentPage;
      this.loadCollectionLogs();
    },
    search() {
      this.page = 1;
      this.loadCollectionLogs();
    },
    clear() {
      this.creatorName = "";
      this.timeRange = "";
      this.searchParams = {};
      this.search();
    },
    timeChange(val) {
      if (val && val.length) {
        this.searchParams.startTime = val[0];
        this.searchParams.endTime = val[1];
      } else {
        this.searchParams.startTime = "";
        this.searchParams.endTime = "";
      }
    },
    /**
     * 导出
     */
    async download() {
      const exportCollectionLogRes = await exportCollectionLog(
        this.currentUser.id,
        this.searchParams
      );
      this.$message.success(exportCollectionLogRes.data);
    },
    async querySearch(queryString, cb) {
      const results = [];
      if (queryString) {
        const getUserRes = await getUser(queryString);
        if (getUserRes.data.length > 0) {
          getUserRes.data.map((item) => {
            results.push({
              value: item.name,
              id: item.id,
            });
          });
        }
      }
      cb(results);
    },
    handleSelect(item) {
      this.searchParams.creatorId = item.id;
    },
    operatorChange(val) {
      if (!val) {
        this.searchParams.creatorId = "";
      }
    },
  },
};
</script>
